"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findFirstAvailableSlot = exports.getNewDesignFromDesignGroup = exports.getNumEditableTextLayersInPrintable = exports.getEditableTextLayersInPrintable = exports.getEditableTextLayersOnPageOrSpread = void 0;
const EditableTextLayer_1 = require("../../../models/layers/EditableTextLayer");
const layers_1 = require("../../../helpers/HAMMER/layers");
const designs_1 = require("../../../services/designs");
const layers_2 = require("../../../services/layers");
const either_1 = require("../../../types/either");
const constants_1 = require("./constants");
const getEditableTextLayersOnPageOrSpread = (printable, activePage) => {
  if (printable.isCompositeDesign) {
    if (activePage === layers_2.CoverageType.RIGHT) {
      return printable.layers.filter(l => (0, EditableTextLayer_1.isEditableTextLayer)(l) && l.x >= 0.5);
    } else {
      return printable.layers.filter(l => (0, EditableTextLayer_1.isEditableTextLayer)(l) && l.x < 0.5);
    }
  } else {
    return printable.layers.filter(EditableTextLayer_1.isEditableTextLayer);
  }
};
exports.getEditableTextLayersOnPageOrSpread = getEditableTextLayersOnPageOrSpread;
const getEditableTextLayersInPrintable = printable => printable.layers.filter(EditableTextLayer_1.isEditableTextLayer);
exports.getEditableTextLayersInPrintable = getEditableTextLayersInPrintable;
const getNumEditableTextLayersInPrintable = printable => {
  return (0, exports.getEditableTextLayersInPrintable)(printable).length;
};
exports.getNumEditableTextLayersInPrintable = getNumEditableTextLayersInPrintable;
// This helper gets the next design id with one more editable text layer in the design group.
const getNewDesignFromDesignGroup = (designGroup, printableId, template, currentNumEditableTextLayers) => {
  for (const designId of designGroup.designs) {
    const designResult = (0, designs_1.findMatchingOrDefaultDesign)({
      newTemplateDesigns: template.designs,
      designId: designId
    });
    if (designResult.isLeft()) {
      return (0, either_1.left)(designResult.value);
    }
    const layersResult = (0, layers_1.getMatchingLayers)(template.layers, designResult.value.layers);
    if (layersResult.isLeft()) {
      return (0, either_1.left)(new Error(`Could not find matching layers for design id: ${designResult.value.id}`));
    }
    const numEditableTextLayer = layersResult.value.filter(EditableTextLayer_1.isEditableTextLayer).length;
    if (numEditableTextLayer >= currentNumEditableTextLayers + 1) {
      return (0, either_1.right)(designResult.value);
    }
  }
  // This means we have the max number of Editable Text Layers
  return (0, either_1.left)(new Error(`Could not add more Editable Text Layers to the current printable: ${printableId}, max is ${currentNumEditableTextLayers}`));
};
exports.getNewDesignFromDesignGroup = getNewDesignFromDesignGroup;
const isInSameSpot = (a, b) => Math.abs(a - b) < constants_1.TEXTBOX_POSITION_THRESHOLD;
const findFirstAvailableSlot = (existingLayers, startingX) => {
  for (let offset = 0; offset < 6; offset++) {
    for (let tier = 0; tier < 3; tier++) {
      const currentY = constants_1.DEFAULT_Y_POSITIONS[tier] + offset * constants_1.OFFSET_Y_DISTANCE;
      const currentX = startingX + offset * constants_1.OFFSET_X_DISTANCE;
      const spotTaken = existingLayers.find(layer => isInSameSpot(layer.y, currentY) && isInSameSpot(layer.x, currentX));
      if (!spotTaken) {
        return {
          newX: currentX,
          newY: currentY
        };
      }
    }
  }
  throw new Error('No more room for additional text boxes.'); // The 6th layer added in a tier (if none of them have been moved) is the last one that will fit on the printable
};

exports.findFirstAvailableSlot = findFirstAvailableSlot;